import React from 'react'
import './route-header.scss'

const RouteHeader = ({children}) => {
  return <h2 className="route-header">
    {children}
  </h2>
}

export default RouteHeader